<head>
  <meta charset="utf-8">
  <meta content="width=device-width, initial-scale=1.0" name="viewport">

  <title>SAION - Tecnología gubernamental</title>
  <meta content="" name="description">
  <meta content="" name="keywords">

  <!-- Favicons -->
  <link href="/assets/img/favicon.png" rel="icon">
  <link href="/assets/img/apple-touch-icon.png" rel="apple-touch-icon">
<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Open+Sans:wght@400;500;600&display=swap" rel="stylesheet">

  <!-- Google Fonts -->
  <link
    href="https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Roboto:300,300i,400,400i,500,500i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i"
    rel="stylesheet">

  <!-- Vendor CSS Files -->
  <link href="/assets/vendor/animate.css/animate.min.css" rel="stylesheet">
  <link href="/assets/vendor/aos/aos.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap/css/bootstrap.min.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap-icons/bootstrap-icons.css" rel="stylesheet">
  <link href="/assets/vendor/boxicons/css/boxicons.min.css" rel="stylesheet">
  <link href="/assets/vendor/glightbox/css/glightbox.min.css" rel="stylesheet">
  <link href="/assets/vendor/remixicon/remixicon.css" rel="stylesheet">
  <link href="/assets/vendor/swiper/swiper-bundle.min.css" rel="stylesheet">
<link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap" rel="stylesheet">
  <!-- Template Main CSS File -->
  <link href="/assets/css/style.css" rel="stylesheet">

  <!-- =======================================================
  * Template Name: Company - v4.7.0
  * Template URL: https://bootstrapmade.com/company-free-html-bootstrap-template/
  * Author: BootstrapMade.com
  * License: https://bootstrapmade.com/license/
  ======================================================== -->
</head>



<footer class="footer">
  <div class="footer-container">

    <!-- Logo y texto -->
    <div class="footer-brand">
      <img src="https://i.imgur.com/WiKsWcr.png" alt="Casimiro Castillo">

    </div>

    <!-- Columnas de enlaces -->
    <div class="footer-links">
      <div>
        <h4 style="font-family: Poppins;" style="font-family: Poppins;">AYUNTAMIENTO</h4>
        <a href="admin/presidente" style="font-family: Poppins;">Directorio</a> <br>
        <a href="admin/equipo-de-trabajo" style="font-family: Poppins;">Equipo de Trabajo</a><br>
        <a href="/admin/organigrama">Organigrama</a>
      </div>

      <div>
        <h4 style="font-family: Poppins;" style="font-family: Poppins;">PROGRAMAS SOCIALES</h4>
        <a href="#" style="font-family: Poppins;">Registro Civil</a> <br>
        <a href="#" style="font-family: Poppins;">Atención Ciudadana</a><br>
        <a href="#" style="font-family: Poppins;">Licencias</a><br>
        <a href="#" style="font-family: Poppins;">Seguridad Pública</a><br>
        <a href="#" style="font-family: Poppins;">Permiso de Construcción</a><br>
        <a href="#" style="font-family: Poppins;">Catastro</a>
      </div>

      <div>
        <h4 style="font-family: Poppins;">TRANSPARENCIA</h4>
        <a href="https://transparencia.dif.casimirocastillo.gob.mx/admin/articulo-8" style="font-family: Poppins;">Artículo 8</a>


      </div>


    </div>

    <!-- Contacto y redes -->
    <div class="footer-contact">
      <div class="social">
       <a href="https://www.facebook.com/difcasimirocastillooficial" target="_blank"><img src="https://i.imgur.com/jQcvZZ2.png"></a>

      </div>

      <p style="font-family: Poppins;">
       Av. Hidalgo No. 1, Col. Centro. La Resolana,<br> <br>
        Casimiro Castillo,<br><br>
        Jalisco, México<br><br>
        Télefono: 357 388 0650<br>
       Correo: casimirocastillo@difjalisco.gob.mx
      </p>
    </div>

  </div>


<div class="row" style="margin: auto;">

  <div class="col-2">
    <p><a href="admin/avisos-de-privacidad">

       <strong style="font-family: Poppins;">Avisos de Privacidad</strong><br>

    </a>


        <br>
        <a href="http://sideclaracasimiro.sytes.net" target="_blank">
 <strong style="font-family: Poppins;">Sistema de Declaraciones</strong><br>

        </a>


      </p>


  </div>

<div class="col-1"></div>


  <div class="col-4"><img height="" src="https://i.imgur.com/ZOF9YPq.png" alt="">
</div>

<div class="col-1"></div>

 <div class="col-2">
  <div class="footer-logos">
   <a href=""><img src="https://i.imgur.com/5EnWCOp.png" alt="911"></a>
  <a href="https://www.facebook.com/people/Comisaría-de-Seguridad-Pública-de-Casimiro-Castillo/100075627416754/"><img src="https://i.imgur.com/UsMzsHC.png" alt="Policía"></a>
   <a href="https://www.facebook.com/casimirocastilloproteccioncivil"> <img src="https://i.imgur.com/eLaORu9.png" alt="Protección Civil"></a>
  </div>
</div>


</div>



  <!-- Logos inferiores -->

  <!-- Barra verde -->
  <div class="footer-bottom">
    © 2026 H. Ayuntamiento de Casimiro Castillo. Todos los derechos reservados.
  </div>
</footer>
